'use client';

import { RadioGroup } from '@shared/shared-shadcn-ui';
import { StepNumber } from '../step-number/step-number';
import { FormRadioButton } from '../form-radio-button/form-radio-button';
import { FormButton } from '../../../../../../../_libs/components/components';
import { useState } from 'react';
import ArrowRightIcon from '../../../../../../../../../public/svg/arrow-right.svg';

type Properties = {
  onContinue: () => void;
};

const DiabetDiagnosStep = ({ onContinue }: Properties) => {
  const [selectedDiabetDiagnos, setSelectedDiabetDiagnos] = useState<
    string | null
  >(null);

  return (
    <div>
      <div className="flex justify-center xl:ml-[150px] xl:justify-start gap-x-6 items-center bg-white rounded-t-lg py-10">
        <StepNumber number={3} />
        <h4 className="text-[30px] lg:text-[44px] text-ogn-blue font-bold leading-normal">
          Have you been diagnosed with diabetes?
        </h4>
      </div>
      <RadioGroup
        className="pl-[74px] lg:pl-0"
        value={selectedDiabetDiagnos}
        onValueChange={(value) => setSelectedDiabetDiagnos(value)}
      >
        <div className="flex flex-col lg:flex-row justify-center gap-y-6 gap-x-12 w-full max-w-[1200px]">
          <FormRadioButton label="Yes, Type 1" value="1" />
          <FormRadioButton label="Yes, Type 2" value="2" />
          <FormRadioButton label="No" value="3" />
        </div>
      </RadioGroup>
      <FormButton
        className="mx-auto w-[300px] my-16 font-roboto-condensed"
        onClick={onContinue}
        isDisabled={!selectedDiabetDiagnos}
      >
        Next
        <ArrowRightIcon className="w-6 h-6" />
      </FormButton>
    </div>
  );
};

export { DiabetDiagnosStep };
